<template>
  <khrc-navbar/>
  <clinical-lab-component />
</template>

<script>
import ClinicalLabComponent from "@/components/ClinicalLabComponent";
import KhrcNavbar from "@/components/KhrcNavbar.vue";
export default {
  components: {
    KhrcNavbar,
    ClinicalLabComponent,
  },
};
</script>

<style></style>
